import f from "../../deserialize/make/useMakeYoutubeJson.js";
import i from "./useLazyFetchJson.js";
import * as l from "ramda";
import { useState as h, useCallback as b } from "react";
const J = "https://www.youtube.com/oembed?format=json&url=", y = () => {
  const {
    loading: a,
    fetchJson: o
  } = i(), {
    makeYoutubeJson: s
  } = f(), [c, r] = h(null), u = b(async (e) => {
    const m = l.map((t) => o(`${J}${t}`), e), n = (await Promise.all(m)).map((t, p) => s(t, e[p]));
    return r(n), n;
  }, [o, s]);
  return {
    data: c,
    isFetching: a,
    fetch: u
  };
};
export {
  y as default
};
//# sourceMappingURL=useFetchYoutubeJson.js.map
